import React from "react";
import stl from "./productInTable.module.scss";
import { IChildren, IStyleProps } from "@/src/app/interface";
import classnames from "classnames";

interface IProps extends IStyleProps {
    // data: any[];
    // type: string;
}
const ProductInTable: React.FC<IProps & IChildren> = (props) => {
    return (
        <div
            className={classnames(stl["page-item"], props.className)}
            style={props.style}
        >
            {props.children[0]}

            <div className={stl["similar-frames-container"]}>
                <p className={stl["similar-frames"]}>{props.children[1]}</p>
                {props.children[2]}
            </div>
        </div>
    );
};

export default ProductInTable;
